import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1758564948745-8a12069beedf?w=1920&q=80';

const SERVICE_CARDS = [
  { key: 'materials_s1', img: 'https://images.unsplash.com/photo-1752980628969-62c587373c62?w=600&q=80' },
  { key: 'materials_s2', img: 'https://images.pexels.com/photos/2469/building-construction-building-site-constructing.jpg?auto=compress&cs=tinysrgb&w=600' },
  { key: 'materials_s3', img: 'https://images.pexels.com/photos/6104931/pexels-photo-6104931.jpeg?auto=compress&cs=tinysrgb&w=600' },
  { key: 'materials_s4', img: 'https://customer-assets.emergentagent.com/job_0a2be3ae-68ce-414a-b1fb-5ae16a7a4416/artifacts/pyjxgm5u_betonschaeden-hero.jpg' },
  { key: 'materials_s5', img: 'https://images.unsplash.com/photo-1594725119088-90a5efa84c83?w=600&q=80' },
  { key: 'materials_s12', img: 'https://customer-assets.emergentagent.com/job_0a2be3ae-68ce-414a-b1fb-5ae16a7a4416/artifacts/krg0k0zq_103974075_8db3682a39.jpg' },
];

export const StudioMaterials = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16" style={{ fontFamily: 'IBM Plex Sans,sans-serif' }}>
      <SEO title="Materials Consulting | Durable Designs" path="/engineering/services/materials" />

      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0">
          <img src={HERO_IMAGE} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-gradient-directional" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto">
          <Link to="/engineering/services" className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors mb-8" data-testid="back-to-studios">
            <ArrowLeft className="w-4 h-4" />{t('services.back')}
          </Link>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tighter" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }} data-testid="studio-materials-heading">
            {t('eng_v2.materials_title')}
          </h1>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mb-12">
            <p className="text-base text-gray-600 leading-relaxed mb-4">{t('services.materials_intro_1')}</p>
            <p className="text-base text-gray-600 leading-relaxed">{t('services.materials_intro_2')}</p>
          </div>

          <h2 className="text-xs font-semibold tracking-[0.15em] uppercase text-gray-400 mb-8" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>
            {t('services.services_label')}
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="materials-service-cards">
            {SERVICE_CARDS.map((card) => (
              <div key={card.key} className="flex flex-col sm:flex-row border border-gray-200 overflow-hidden items-start" data-testid={`service-card-${card.key}`}>
                <div className="service-image-container">
                  <img
                    src={card.img}
                    alt={t(`services.${card.key}_alt`)}
                    width="600"
                    height="600"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex-1 p-5 sm:p-6 flex flex-col justify-center">
                  <h3 className="text-base font-semibold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>
                    {t(`services.${card.key}_title`)}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {t(`services.${card.key}_desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 border border-gray-200 p-6 bg-emerald-50/50">
            <p className="text-sm text-gray-600">{t('services.materials_testing')}</p>
          </div>

          <div className="mt-12">
            <Link to="/engineering/contact" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors" data-testid="studio-materials-cta">
              {t('services.discuss')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
export default StudioMaterials;
